import Currency from '../../../../../common/components/Currency.js'
import {
  shippedInsuredValueSelector,
  shippedInsuranceCostSelector,
} from '../../../../../data/orders.js'
import {useSelector} from '../../../../../store.js'

export default function ShippedInsuranceItem({orderNumber}) {
  const insuranceCost = useSelector((state) =>
    shippedInsuranceCostSelector(state, {orderNumber}),
  )
  const insuredValue = useSelector((state) =>
    shippedInsuredValueSelector(state, {orderNumber}),
  )

  return (
    <li className="list__item--order-data list__item--shipping-info">
      <strong className="margin-right-3">
        Third-Party Insurance (via Shipsurance):
      </strong>
      {insuredValue ? (
        <span>
          <Currency value={insuranceCost || 0} currencySymbol="$" /> (
          <Currency value={insuredValue} currencySymbol="$" /> of coverage)
        </span>
      ) : (
        <em>None</em>
      )}
    </li>
  )
}
